import {
  BrowserRouter,
  Route,
  Routes,
  Outlet,
  Navigate,
  useParams,
} from "react-router-dom";

import PrivateRoutes from "./routes/PrivateRoutes.jsx";
import NotFound from "./pages/404/NotFound.jsx";

import WithSideBarLayout from "./layouts/WithSideBarLayout";
import WithSideBarAdmLayout from "./layouts/WithSideBarAdmLayout";

import Atualizarsenha from "./pages/AtualizarSenha/atualizasenha.jsx";
import Atualizarcadastro from "./pages/AtualizarCadastro/atualizarcadastro.jsx";

import RestricaoUsuario from "./routes/RotasUsuarioExibe/RestricaoUsuario.jsx";

import Login from "./pages/Login";
import Login2 from "./pages/Administrador";

import RecuperarSenha from "./pages/RecuperarSenha";
import RnovaSenha from "./pages/RecuperarSenha/NovaSenhaR";





import Grupos from "./components/Grupos/Grupos";
import Grupo_edicao from "./components/Grupos/GruposEdicao.js";
import Grupos_cad from "./components/Grupos/GruposCad.js";

import Icones from "./components/Icones/Icones";

import Manutencao from "./components/Manutencao/Manutencao";
import ManutencaoRealizada from "./components/ManutençãoRealizada/Realizada.js";

import Motoristas from "./components/Relatorios/Motorista/Motorista.js";
import Cadastro_motorista from "./components/Motorista/MotoristaCad.js";
import MotoristaUp from "./components/Motorista/MotoristaUp.js";

import Enfermeiros from "./components/Enfermeiro/Enfermeiro";
import EnfermeiroUp from "./components/Enfermeiro/EnfermeiroUp";

import NotificaçãoCad from "./components/Notificacao/NotificacaoCad.js";
import Notificacao from "./components/Notificacao/Notificacao.js";
import NotificacaoRelatorio from "./components/Relatorios/Notificacao/Notificacao.js"

import Usuario from "./components/Usuario/Usuario.js";
import UsuarioCad from "./components/Usuario/UsuarioCad.js";
import UsuarioEdit from "./components/Usuario/UsuarioUp.js";

import PolygonsMaps from "./pages/PolygonsMaps";

import Alertas from "./components/Notificacao/Alertas";

import Usuarios from "./components/Usuario/Usuario";


// import Relatorios from "././components/Relatorios/Principal";
import PosicaoRelatorio from "./components/Relatorios/Posicao/Posicao.js";

/*
============================================================
ADMINISTRADOR
============================================================
*/

import PrincipalAdm from "./componentsAdm/GraficoAdm";
import UsuariosAdm from "./componentsAdm/Usuarios";
import UsuariosAdmCad from "./componentsAdm/Usuarios/usuarioAdm";
import UsuariosAdmUp from "./componentsAdm/Usuarios/usuarioAdmUp";

/*
============================================================
RELATÓRIO DE PRODUTIVIDADE
============================================================
*/

import ProdutividadeRelatorio from "./components/Relatorios/Produtividade/RelatorioProdutividade.js";



/*
============================================================
RELATÓRIOS PERMITIDOS
============================================================

Aqui ficam somente os tipos de relatório que realmente
existem no sistema.

Se alguém tentar acessar:

/relatorio/teste
/relatorio/abc
/relatorio/qualquer-coisa

será enviado para o 404.

Para adicionar um novo relatório no futuro, basta colocar
o nome dele nessa lista e tratar dentro de RotaRelatorio().
============================================================
*/

const relatoriosPermitidos = [
  "posicao",
  "motorista",
  "produtividade",
  "relatorio-notificacao",

  // Futuros relatórios:
  // "jornada",
  // "paradas",
  // "velocidade",
];


/*
============================================================
ROTA DINÂMICA DOS RELATÓRIOS
============================================================

A rota principal é:

/relatorio/:tipo

Exemplos:

/relatorio/posicao
    -> PosicaoRelatorio

/relatorio/motorista
    -> PosicaoRelatorio

/relatorio/produtividade
    -> ProdutividadeRelatorio

/relatorio/qualquer-coisa
    -> 404

============================================================
*/

function RotaRelatorio() {

  /*
  ----------------------------------------------------------
  Pega o parâmetro "tipo" da URL
  ----------------------------------------------------------

  Exemplo:

  /relatorio/produtividade

  tipo = "produtividade"
  ----------------------------------------------------------
  */

  const { tipo } = useParams();


  /*
  ----------------------------------------------------------
  Normaliza o tipo do relatório
  ----------------------------------------------------------

  Isso evita problemas com:

  " Produtividade "
  "PRODUTIVIDADE"
  "Produtividade"

  Todos serão tratados como:

  "produtividade"
  ----------------------------------------------------------
  */

  const tipoRelatorio = String(tipo || "")
    .trim()
    .toLowerCase();


  /*
  ----------------------------------------------------------
  Verifica se o relatório existe
  ----------------------------------------------------------
  */

  const relatorioPermitido =
    relatoriosPermitidos.includes(tipoRelatorio);


  /*
  ----------------------------------------------------------
  RELATÓRIO NÃO EXISTE
  ----------------------------------------------------------

  Se o usuário tentar acessar um relatório que não está
  cadastrado na lista acima, vai para o 404.

  replace evita deixar a URL inválida no histórico.
  ----------------------------------------------------------
  */

  if (!relatorioPermitido) {
    return <Navigate to="/404" replace />;
  }


  /*
  ==========================================================
  RELATÓRIO DE PRODUTIVIDADE
  ==========================================================

  Quando a URL for:

  /relatorio/produtividade

  será carregado:

  ProdutividadeRelatorio
  ==========================================================
  */

  if (tipoRelatorio === "produtividade") {
    return <ProdutividadeRelatorio />;
  }
  if (tipoRelatorio === "relatorio-notificacao") {
    return <NotificacaoRelatorio />;
  }



  /*
  ==========================================================
  OUTROS RELATÓRIOS
  ==========================================================

  Por enquanto:

  /relatorio/posicao
  /relatorio/motorista

  continuam usando o componente original:

  PosicaoRelatorio

  
  ==========================================================
  */

  return <PosicaoRelatorio />;
}


/*
==============================================================
ROTAS PRINCIPAIS
==============================================================
*/

export default function Rotas() {

  return (

    <Routes>

      {/* =====================================================
          ROTAS PÚBLICAS
          ===================================================== */}

      <Route
        path="/"
        element={<Login />}
      />

      <Route
        path="/recuperar-senha"
        element={<RecuperarSenha />}
      />

      <Route
        path="/nova-senha"
        element={<RnovaSenha />}
      />

      <Route
        path="/login-admin"
        element={<Login2 />}
      />


      {/* =====================================================
          ROTAS PRIVADAS
          ===================================================== */}

      <Route element={<PrivateRoutes />}>

        <Route
          element={
            <RestricaoUsuario>
              <Outlet />
            </RestricaoUsuario>
          }
        >


          {/* =================================================
              ATUALIZAÇÃO DE SENHA
              ================================================= */}

          <Route
            path="/atualizacao-senha"
            element={<Atualizarsenha />}
          />


          {/* =================================================
              ATUALIZAÇÃO DE CADASTRO
              ================================================= */}

          <Route
            path="/atualizacao-cadastro"
            element={<Atualizarcadastro />}
          />


          {/* =================================================
              RELATÓRIOS
              =================================================

              IMPORTANTE:

              Não precisa criar uma Route para cada relatório.

              A rota dinâmica:

              /relatorio/:tipo

              chama RotaRelatorio(), que decide qual
              componente deve ser exibido.
              ================================================= */}

          <Route
            path="/relatorio/:tipo"
            element={<RotaRelatorio />}
          />


          {/* =================================================
              SISTEMA / MAPS
              ================================================= */}

          <Route
            path="/maps"
            element={<WithSideBarLayout />}
          >

            {/* Página inicial do /maps */}
            <Route
              index
              element={null}
            />


            {/* =================================================
                ENFERMEIROS
                ================================================= */}

            <Route
              path="enfermeiro"
              element={<Enfermeiros />}
            />

            <Route
              path="enfermeiro-up"
              element={<EnfermeiroUp />}
            />


            {/* =================================================
                GRUPOS
                ================================================= */}

            <Route
              path="grupos"
              element={<Grupos />}
            />

            <Route
              path="grupos-edicao/:id"
              element={<Grupo_edicao />}
            />

            <Route
              path="grupos-cad"
              element={<Grupos_cad />}
            />


            {/* =============================================================
                MANUTENÇÃO
                =============================================================*/}
            <Route
              path="manutencao"
              element={<Manutencao/>}
            />

            <Route
              path="manutencao-realizada"
              element={<ManutencaoRealizada/>}
            />






            {/* =================================================
                ÍCONES
                ================================================= */}

            <Route
              path="icones"
              element={<Icones />}
            />


            {/* =================================================
                MOTORISTAS
                ================================================= */}

            <Route
              path="motorista"
              element={<Motoristas />}
            />

            <Route
              path="cadastro-motorista"
              element={<Cadastro_motorista />}
            />

            <Route
              path="editar-motorista"
              element={<MotoristaUp />}
            />


            {/* =================================================
                NOTIFICAÇÕES
                ================================================= */}

            <Route
              path="notificacao"
              element={<Notificacao />}
            />

            <Route
              path="cadastro-notificacao"
              element={<NotificaçãoCad />}
            />


            <Route
              path="editar-notificacao/:id"
              element={
                <NotificaçãoCad modo="edit" />
              }
            />


            {/* =================================================
                USUÁRIOS
                ================================================= */}

            <Route
              path="usuarios"
              element={<Usuario />}
            />

            <Route
              path="cadastro-usuarios"
              element={<UsuarioCad />}
            />

            <Route
              path="editar-usuario/:id"
              element={<UsuarioEdit />}
            />


            {/* =================================================
                ALERTAS
                ================================================= */}

            <Route
              path="alertas"
              element={<Alertas />}
            />


            {/* =================================================
                ÁREAS / ROTAS
                ================================================= */}

            <Route
              path="areas-rotas"
              element={<PolygonsMaps />}
            />


            {/* =================================================
                404 DENTRO DO MAPS
                ================================================= */}

            <Route
              path="*"
              element={<NotFound />}
            />

          </Route>

        </Route>

      </Route>


      {/* =====================================================
          404 EXPLÍCITO
          ===================================================== */}

      <Route
        path="/404"
        element={<NotFound />}
      />


      {/* =====================================================
          QUALQUER ROTA QUE NÃO EXISTIR
          ===================================================== */}

      <Route
        path="*"
        element={<NotFound />}
      />

    </Routes>

  );
}